"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _variables = _interopRequireDefault(require("../utils/variables"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var styles = function styles(theme) {
  var primaryColor = _variables["default"].iconColor.primary;
  var warningColor = _variables["default"].iconColor.warning;
  var dangerColor = _variables["default"].iconColor.danger;
  var whiteColor = _variables["default"].iconColor.white;
  var darkColor = _variables["default"].iconColor.dark;
  var progressColor = _variables["default"].iconColor.progress;
  var redColor = _variables["default"].iconColor.red;
  var defaultColor = _variables["default"].iconColor["default"];
  var purpleColor = _variables["default"].iconColor.purple;
  var blueColor = _variables["default"].iconColor.blue;
  var yellowColor = _variables["default"].iconColor.yellow;
  return {
    iconCommon: {
      fontFamily: "payuicons !important",
      speak: "none",
      fontStyle: "normal",
      fontWeight: "normal",
      fontVariant: "normal",
      textTransform: "none",
      lineHeight: "1",
      WebkitFontSmoothing: "antialiased",
      MozOsxFontSmoothing: "grayscale",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center"
    },
    primaryColor: {
      "&::before": {
        color: primaryColor
      }
    },
    warningColor: {
      "&::before": {
        color: warningColor
      }
    },
    dangerColor: {
      "&::before": {
        color: dangerColor
      }
    },
    whiteColor: {
      "&::before": {
        color: whiteColor
      }
    },
    redColor: {
      "&::before": {
        color: redColor
      }
    },
    defaultColor: {
      "&::before": {
        color: defaultColor
      }
    },
    progressColor: {
      "&::before": {
        color: progressColor
      }
    },
    purpleColor: {
      "&::before": {
        color: purpleColor
      }
    },
    blueColor: {
      "&::before": {
        color: blueColor
      }
    },
    yellowColor: {
      "&::before": {
        color: yellowColor
      }
    },
    paymentHandle: {
      "&::before": {
        content: '"\\e93c"'
      }
    },
    "delete": {
      "&::before": {
        content: '"\\e93d"'
      }
    },
    edit: {
      "&::before": {
        content: '"\\e93e"'
      }
    },
    apiReference: {
      "&::before": {
        content: '"\\e900"'
      }
    },
    customerSupport: {
      "&::before": {
        content: '"\\e901"'
      }
    },
    events: {
      "&::before": {
        content: '"\\e902"'
      }
    },
    integration: {
      "&::before": {
        content: '"\\e903"'
      }
    },
    invoices: {
      "&::before": {
        content: '"\\e904"'
      }
    },
    onlineStore: {
      "&::before": {
        content: '"\\e905"'
      }
    },
    Path: {
      "&::before": {
        content: '"\\e906"'
      }
    },
    paymentWebsite: {
      "&::before": {
        content: '"\\e907"'
      }
    },
    paymentlink: {
      "&::before": {
        content: '"\\e908"'
      }
    },
    payout: {
      "&::before": {
        content: '"\\e909"'
      }
    },
    PG: {
      "&::before": {
        content: '"\\e90a"'
      }
    },
    referearn: {
      "&::before": {
        content: '"\\e90b"'
      }
    },
    report: {
      "&::before": {
        content: '"\\e90c"'
      }
    },
    settlement: {
      "&::before": {
        content: '"\\e90d"'
      }
    },
    Shape: {
      "&::before": {
        content: '"\\e90e"'
      }
    },
    smartsend: {
      "&::before": {
        content: '"\\e90f"'
      }
    },
    subscription: {
      "&::before": {
        content: '"\\e910"'
      }
    },
    summary: {
      "&::before": {
        content: '"\\e911"'
      }
    },
    transactions: {
      "&::before": {
        content: '"\\e912"'
      }
    },
    Unchecked: {
      "&::before": {
        content: '"\\e913"'
      }
    },
    support: {
      "&::before": {
        content: '"\\e914"'
      }
    },
    allPaymentOption: {
      "&::before": {
        content: '"\\e915"'
      }
    },
    back: {
      "&::before": {
        content: '"\\e916"'
      }
    },
    Chat: {
      "&::before": {
        content: '"\\e917"'
      }
    },
    CheckboxUnchecked: {
      "&::before": {
        content: '"\\e918"'
      }
    },
    Checklist: {
      "&::before": {
        content: '"\\e919"'
      }
    },
    Copy: {
      "&::before": {
        content: '"\\e91a"'
      }
    },
    Data: {
      "&::before": {
        content: '"\\e91b"'
      }
    },
    dateFilter: {
      "&::before": {
        content: '"\\e91c"'
      }
    },
    Deactivated: {
      "&::before": {
        content: '"\\e91d"'
      }
    },
    doubleBack: {
      "&::before": {
        content: '"\\e91e"'
      }
    },
    Download: {
      "&::before": {
        content: '"\\e91f"'
      }
    },
    dropdown: {
      "&::before": {
        content: '"\\e920"'
      }
    },
    Filter: {
      "&::before": {
        content: '"\\e921"'
      }
    },
    fundManagement: {
      "&::before": {
        content: '"\\e922"'
      }
    },
    Graph: {
      "&::before": {
        content: '"\\e923"'
      }
    },
    Help: {
      "&::before": {
        content: '"\\e924"'
      }
    },
    Info: {
      "&::before": {
        content: '"\\e925"'
      }
    },
    Logout: {
      "&::before": {
        content: '"\\e926"'
      }
    },
    snippet: {
      "&::before": {
        content: '"\\e927"'
      }
    },
    More: {
      "&::before": {
        content: '"\\e928"'
      }
    },
    paymentOverlay: {
      "&::before": {
        content: '"\\e929"'
      }
    },
    paymentResponse: {
      "&::before": {
        content: '"\\e92a"'
      }
    },
    pieChart: {
      "&::before": {
        content: '"\\e92b"'
      }
    },
    Process: {
      "&::before": {
        content: '"\\e92c"'
      }
    },
    productsTab: {
      "&::before": {
        content: '"\\e92d"'
      }
    },
    Profile: {
      "&::before": {
        content: '"\\e92e"'
      }
    },
    responseHash: {
      "&::before": {
        content: '"\\e92f"'
      }
    },
    ResponsiveDesign: {
      "&::before": {
        content: '"\\e930"'
      }
    },
    Search: {
      "&::before": {
        content: '"\\e931"'
      }
    },
    Security: {
      "&::before": {
        content: '"\\e932"'
      }
    },
    Settings: {
      "&::before": {
        content: '"\\e933"'
      }
    },
    Share: {
      "&::before": {
        content: '"\\e934"'
      }
    },
    transactionTrack: {
      "&::before": {
        content: '"\\e93a"'
      }
    },
    pciDss: {
      "&::before": {
        content: '"\\e93b"'
      }
    },
    goTo: {
      "&::before": {
        content: '"\\e936"'
      }
    },
    visaVerified: {
      "&::before": {
        content: '"\\e941"'
      }
    },
    nortonSecure: {
      "&::before": {
        content: '"\\e942"'
      }
    },
    mastercard: {
      "&::before": {
        content: '"\\e940"'
      }
    },
    amex: {
      "&::before": {
        content: '"\\e93f"'
      }
    },
    payuLogo: {
      "&::before": {
        content: '"\\e939"'
      }
    },
    alert: {
      "&::before": {
        content: '"\\e943"'
      }
    },
    hourGlass: {
      "&::before": {
        content: '"\\e944"'
      }
    },
    tick: {
      "&::before": {
        content: '"\\e945"'
      }
    },
    exclm: {
      "&::before": {
        content: '"\\e946"'
      }
    },
    lock: {
      "&::before": {
        content: '"\\e947"'
      }
    },
    view: {
      "&::before": {
        content: '"\\e948"'
      }
    },
    newBanner1: {
      "&::before": {
        content: '"\\e94a"'
      }
    },
    academy: {
      "&::before": {
        content: '"\\e94d"'
      }
    },
    cancel: {
      "&::before": {
        content: '"\\e94e"'
      }
    },
    dragOrder: {
      "&::before": {
        content: '"\\e94f"'
      }
    },
    notification: {
      "&::before": {
        content: '"\\e956"'
      }
    },
    check: {
      "&::before": {
        content: '"\\e952"'
      }
    },
    greenTick: {
      "&::before": {
        content: '"\\e950"'
      }
    },
    progress: {
      "&::before": {
        content: '"\\e953"'
      }
    },
    email: {
      "&::before": {
        content: '"\\e954"'
      }
    },
    infoInvert: {
      "&::before": {
        content: '"\\e955"'
      }
    },
    badge: {
      "&::before": {
        content: '"\\e958"'
      }
    },
    star: {
      "&::before": {
        content: '"\\e951"'
      }
    },
    chargeback: {
      "&::before": {
        content: '"\\e949"'
      }
    },
    newTab: {
      "&::before": {
        content: '"\\e959"'
      }
    },
    generalProfile: {
      "&::before": {
        content: '"\\e94c"'
      }
    },
    statement: {
      "&::before": {
        content: '"\\e94b"'
      }
    },
    overview: {
      "&::before": {
        content: '"\\e95d"'
      }
    },
    trend: {
      "&::before": {
        content: '"\\e95c"'
      }
    },
    settlements: {
      "&::before": {
        content: '"\\e95a"'
      }
    },
    union: {
      "&::before": {
        content: '"\\e95b"'
      }
    },
    bankStatement: {
      "&::before": {
        content: '"\\e957"'
      }
    },
    paperMoney: {
      "&::before": {
        content: '"\\e95e"'
      }
    },
    digiLock: {
      "&::before": {
        content: '"\\e95f"'
      }
    },
    upload: {
      "&::before": {
        content: '"\\e960"'
      }
    },
    upArrow: {
      "&::before": {
        content: '"\\e961"'
      }
    },
    knowMore: {
      "&::before": {
        content: '"\\e966"'
      }
    },
    split: {
      "&::before": {
        content: '"\\e967"'
      }
    },
    activate: {
      "&::before": {
        content: '"\\e963"'
      }
    },
    deactivate: {
      "&::before": {
        content: '"\\e965"'
      }
    },
    mutualFund: {
      "&::before": {
        content: '"\\e964"'
      }
    },
    viewDisabled: {
      "&::before": {
        content: '"\\e968"'
      }
    },
    view1: {
      "&::before": {
        content: '"\\e969"'
      }
    },
    language: {
      "&::before": {
        content: '"\\e96a"'
      }
    },
    clock: {
      "&::before": {
        content: '"\\e96b"'
      }
    },
    flash: {
      "&::before": {
        content: '"\\e96c"'
      }
    },
    refresh: {
      "&::before": {
        content: '"\\e96d"'
      }
    },
    toggle: {
      "&::before": {
        content: '"\\e96e"'
      }
    },
    launchPad: {
      "&::before": {
        content: '"\\e96f"'
      }
    }
  };
};

var _default = styles;
exports["default"] = _default;